import { createFileRoute } from '@tanstack/react-router';

import { guardPermitAdminRoute } from '../modules/Permits/permitAdminRouteGuard';
import { PermitsAdminPage } from '../modules/Permits/PermitsAdminPage';
import { permitListSearchSchema } from '../modules/Permits/PermitsAdminPage/permitListSearch';

export const Route = createFileRoute('/permitting')({
  component: PermitsAdminPage,
  validateSearch: permitListSearchSchema,
  loader({ context }) {
    guardPermitAdminRoute(context.authContext.user);
  },
  head() {
    return {
      meta: [{ title: 'Permitting' }],
    };
  },
});
